import { render, staticRenderFns } from "./app-footer.vue?vue&type=template&id=4801ef24&scoped=true"
import script from "./app-footer.ts?vue&type=script&lang=ts&external"
export * from "./app-footer.ts?vue&type=script&lang=ts&external"
import style0 from "./app-footer.scss?vue&type=style&index=0&id=4801ef24&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4801ef24",
  null
  
)

export default component.exports